import PropTypes from "prop-types"

import { authorizationStoreProperties } from "../stores/useAuthorizationStore"

const AuthorizationStoreShape = PropTypes.exact(authorizationStoreProperties)

export default AuthorizationStoreShape
